// Layer 4 (UI): the page's one `[syn]` mark — a neutral dashed chip, the same
// on the GM band, the hardness pair, the display cards and the curve
// (polish.P11 r1). The source it stands for rides the tooltip.
export function SynChip({ title }: { title?: string }) {
  return (
    <span
      title={title}
      data-syn-chip
      className="inline-flex shrink-0 items-center rounded-full border border-dashed border-[var(--hairline-strong)] px-1.5 font-mono text-[10px] font-normal normal-case leading-4 tracking-normal text-muted"
    >
      [syn]
    </span>
  );
}
